import {
    GET_ALL_IMAGES_ASSEMBLING
} from './constants';

const initialState = {
    imagesAssembling: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_IMAGES_ASSEMBLING: {
            return {
                ...state,
                imagesAssembling: action.payload,
            };
        }
        default:
            return state;
    }
};

